import api from '@pray/shared/utils/api';

import type { SmsConfig } from './types';

type UpdateSmsConfigProps = {
  artistId: string;
  welcome_message?: string | null;
  daily_message_cap?: number;
  rate_limit_reached_message?: string | null;
  is_test_mode?: boolean;
};

export async function updateSmsConfig({
  artistId,
  welcome_message,
  daily_message_cap,
  rate_limit_reached_message,
  is_test_mode,
}: UpdateSmsConfigProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config`;

  const data: Record<string, unknown> = {};
  if (welcome_message !== undefined) data.welcome_message = welcome_message;
  if (daily_message_cap !== undefined) data.daily_message_cap = daily_message_cap;
  if (rate_limit_reached_message !== undefined) data.rate_limit_reached_message = rate_limit_reached_message;
  if (is_test_mode !== undefined) data.is_test_mode = is_test_mode;

  const response = await api.executePutRequest<{ data: SmsConfig }>(url, data);

  return response.data;
}
